<template>
	<div>
		<v-btn
			:loading="loader"
			:disabled="loader || !selected.length"
			@click="dialog = !dialog"
			color="green"
			class="white--text mt-2"
		>Tạo Phiếu Thu Cô Gấm</v-btn>
		<v-dialog v-model="dialog" max-width="80%">
			<app-card>
				<v-form ref="form">
					<h3>TẠO PHIẾU THU CỦA CÔ GẤM</h3>
					<p class="fs-14 grey--text">Tạo phiếu thu tiền phòng, phiếu thu tiền cọc</p>
					<v-container fluid>
						<v-layout row wrap>
							<v-flex xs12>
								<h5>Số lượng phiếu đã chọn: {{selected.length}}</h5>
								<h5>Tổng số tiền phải thu từ các phiếu: {{total_amount_selected | formatNumber}} VND</h5>
								<h5 v-if="total_diff_amount">Số tiền CG {{ total_diff_amount > 0 ? "phải thu thêm" : "đã thu dư" }}: {{ Math.abs(total_diff_amount) | formatNumber}} VND</h5>
							</v-flex>
							<v-flex xs12 md3>
								<v-text-field
									label="Số Chứng Từ Cô Gấm"
									:disabled="loading.submit"
									type="text"
									v-model="form.receipt_id"
									prepend-icon="book"
									:rules="[rules.required]"
								></v-text-field>
							</v-flex>
							<v-flex xs12 md3>
								<v-menu
									:close-on-content-click="false"
									v-model="menu_date_collected"
									:nudge-right="40"
									lazy
									transition="scale-transition"
									offset-y
									full-width
									min-width="290px"
								>
									<v-text-field
										slot="activator"
										v-model="form.date_collected"
										label="Ngày thu"
										:disabled="loading.submit"
										prepend-icon="event"
										readonly
										:rules="[rules.required]"
									></v-text-field>
									<v-date-picker
										locale="vi-VI"
										v-model="form.date_collected"
										@input="menu_date_collected = false"
									></v-date-picker>
								</v-menu>
							</v-flex>
							<v-flex xs12 md3>
								<v-select
									label="Bảo vệ:"
									:disabled="loading.submit"
									v-model="form.collector"
									:items="list_collectors"
									required
									type="text"
									prepend-icon="domain"
									:rules="[rules.required]"
								></v-select>
							</v-flex>
							<v-flex xs12 md3>
								<v-text-field
									:label="`Số tiền cô Gấm thu`"
									v-model="form.total_amount_collected"
									prepend-icon="attach_money"
									:rules="[rules.required]"
								></v-text-field>
							</v-flex>
							<v-flex v-if="real_diff_amount" xs12 class="text-center">
								<span :class="real_diff_amount < 0 ? 'red--text' : 'green--text' ">Số tiền chênh lệch: {{ real_diff_amount | formatNumber }}</span>
							</v-flex>
						</v-layout>
					</v-container>
					<v-card-actions class="justify-center">
						<v-btn
							:loading="loading.submit"
							:disabled="loading.submit"
							@click="submit"
							color="primary"
						>Tạo Phiếu Cô Gấm</v-btn>
					</v-card-actions>
				</v-form>
			</app-card>
		</v-dialog>
	</div>
</template>
<script>
import moment from "moment";
import {
	buildParamQuery,
	formatTimeServer,
	deepCopy
} from "Helpers";
import api from "Api";
export default {
	name: "dialog-tao-phieu-co-gam",
	props: {
		loader: Boolean,
		selected: Array,
		total_amount_selected: Number
	},
	data() {
		return {
			dialog: false,
			form: {
				receipt_id: "",
				date_collected: new Date().toISOString().substring(0, 10),
				total_amount_collected: "",
				diff_amount: 0,
			},
			total_diff_amount: 0,
			menu_date_collected: false,
			loading: {
				submit: false
			},
			rules: {
				required: value => !!value || "Vui lòng điền thông tin này."
			},
            list_collectors: [
                { text: 'BVBN', value: 'BVBN'},
                { text: 'BVGB', value: 'BVGB'},
                { text: 'BVTT', value: 'BVTT'},
                { text: 'BVXA', value: 'BVXA'},
                { text: 'BVMA', value: 'BVMA'},
                { text: 'BVBMT', value: 'BVBMT'}
            ],
		};
	},
	computed: {
		real_diff_amount(){
			return Number(
				this.form.total_amount_collected.replace(/,/g, "")
			) - this.total_amount_selected - this.total_diff_amount
		}
	},
	watch: {
		total_amount_selected: function() {
			
		},
		selected: function (){
			this.total_diff_amount = this.selected.reduce((accu, current) => {
				if (current.type === "DIFFERENCE"){
					return accu - current.receipt_amount
				}
				return accu
			}, 0)
			this.form.total_amount_collected = this.total_amount_selected + this.total_diff_amount;
			this.form.collector = this.selected[0] ? this.selected[0].collector : ''
		},
		"form.total_amount_collected": function(nv, ov) {
			this.form.total_amount_collected = nv
				? nv
						.toString()
						.replace(/,/g, "")
						.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
				: "";
			const total_amount_collected = this.form.total_amount_collected
				? Number(this.form.total_amount_collected.replace(/,/g, ""))
				: 0;
			this.form.diff_amount = (
				total_amount_collected - this.total_amount_selected
			);
		},
	},
	methods: {
		clearInput: function() {
			this.form = {
				receipt_id: "",
				date_collected: new Date().toISOString().substring(0, 10),
				total_amount_collected: "",
				diff_amount: 0
			};
            this.$refs.form.resetValidation();
		},
		submit: async function() {
			if (!this.$refs.form.validate()) {
                swal.fire('Lỗi', 'Vui lòng điền đầy đủ thông tin', 'error');
                return
            }
			this.loading.submit = true;
			let postData = {};
			postData.receipt_id = this.form.receipt_id;
			postData.collector = this.form.collector;
			postData.receipts = [];
			postData.balance_receipt_collected_id = [];
			this.selected.forEach(receipt => {
				postData.receipts.push({
					id: receipt.receipt_id,
					type: receipt.type,
					building: receipt.building,
					room_id: receipt.room_id,
					collector: receipt.collector,
					date_collected: new Date(receipt.receipt_date),
					amount: receipt.receipt_amount,
					month: receipt.month
				})
				if (receipt.type === "DIFFERENCE"){
					// postData.balance_receipt_collected_id.push(receipt.receipt_id)
				}
			})
			postData.real_diff_amount = this.real_diff_amount;
			postData.receipt_count = postData.receipts.length;
			postData.diff_amount = this.form.diff_amount;
			postData.date_collected = new Date(this.form.date_collected);
			postData.total_amount_selected = this.total_amount_selected
			postData.total_amount_collected = Number(
				this.form.total_amount_collected.replace(/,/g, "")
			);
			let data = await api.createReceiptCollected(postData);
			if (data.status === 200) {
				this.dialog = false;
				this.$emit("getReceiptData");
				this.clearInput();
				swal.fire("Thành công", "Tạo phiếu thu thành công", "success");
			} else {
				swal.fire("Lỗi", data.message, "error");
			}
			this.loading.submit = false;
		}
	}
};
</script>

